import { render, staticRenderFns } from "./ProxyPackageSearch.vue?vue&type=template&id=5b3c2b02"
import script from "./ProxyPackageSearch.vue?vue&type=script&lang=js"
export * from "./ProxyPackageSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports